import { render, staticRenderFns } from "./DetalleCompra.vue?vue&type=template&id=8bbfcfba&scoped=true"
import script from "./DetalleCompra.vue?vue&type=script&lang=js"
export * from "./DetalleCompra.vue?vue&type=script&lang=js"
import style0 from "./DetalleCompra.vue?vue&type=style&index=0&id=8bbfcfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbfcfba",
  null
  
)

export default component.exports